import { MultilocationIcon } from '../../atoms/icons'


export default function MultioutletBanner() {
    return (
        <section
                role="banner"
                className="py-5 px-10 bg-primary text-secondary2 text-base"
                id="secondary_banner"
            >
                <div
                    className='flex flex-row md:flex-col justify-center items-center'
                >
                    <div className="align self-center mr-1 md:mr-0 md:mb-2 w-8">
                        <MultilocationIcon />
                    </div>
                    <p
                        className='ml-3 md:text-center'
                    >
                        The Shopkeeper is designed  with mulit-outlet businesses in mind. 
                        <br className='md:hidden' />
                        It scales to fit your retail game.
                    </p>
                </div>

        </section>
    )
}
